export default __webpack_public_path__ + "static/media/cube.ef1958a7.png";